import { forwardRef } from "react";
import { clsx } from "clsx";
import { useRadioProps } from "./useRadioProps";
import classes from "./Radio.module.scss";
import { RadioProps, RadioVariant } from "./RadioProps";
import { Check } from "../Icon/Check";
import { Times } from "../Icon/Times";

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  props: RadioProps,
  inputRef: React.Ref<HTMLInputElement>,
) {
  const { children, className, id, variant, ...inputProps } =
    useRadioProps<RadioProps>(props);

  const wrapClasses = clsx(classes.wrap, {
    [classes.check]: variant === RadioVariant.Check,
    [classes.times]: variant === RadioVariant.Times,
  });

  return (
    <label className={clsx(classes.label, className)} htmlFor={id}>
      <span className={wrapClasses}>
        <input
          type="radio"
          ref={inputRef}
          className={classes.input}
          id={id}
          {...inputProps}
        />

        <span className={classes.icon}>
          {!variant && <span className={classes.dot}></span>}

          {variant === RadioVariant.Check && (
            <Check
              strokeWidth={4}
              stroke="currentColor"
              className={classes.svgIcon}
            />
          )}

          {variant === RadioVariant.Times && (
            <Times
              strokeWidth={4}
              stroke="currentColor"
              className={classes.svgIcon}
            />
          )}
        </span>
      </span>
      <span>{children}</span>
    </label>
  );
});
